/**
 * The id `PillTabs` gives each tab, so the caller's `role="tabpanel"` can name
 * the active one in `aria-labelledby`. Its own file so `PillTabs.tsx` exports
 * only a component (`react-refresh/only-export-components`).
 */
export function pillTabId(idPrefix: string, value: string): string {
  return `${idPrefix}-tab-${value}`
}
